import { i18nInstance } from '../plugins/localization'
import $ from 'jquery'
import $store from '../store'
import $sc from './shortcut.collection.js'

export default (message) => {
  if (message == null) {
    return
  }

  if (!message.buttons || !Array.isArray(message.buttons) || message.buttons.length === 0) {
    message.buttons = [{
      title: i18nInstance.global.t('dialog.seen'),
      shortcut: $sc.find('ok', 'dialog'),
      isPrimary: true, 
      handle: (button, page, e) => {
      }
    }]
  }

  let focusedEl = $(':focus')

  return new Promise((resolve, reject) => {
    message.resolve = resolve
    message.reject = reject
    message.focusedEl = focusedEl

    setTimeout(() => {
      $store.dispatch('addMessage', message)
    }, 50)
  })
}
